/* Imports */
import React from "react"
import { Flexbox, Avatar } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const AvatarPage = () => {
    const items = [
        {
            title: "With a picture",
            content: (
                <Flexbox gap="s" wrap="wrap">
                    <Avatar src="/images/pic-avatar.jpg" size="xxl" />
                    <Avatar src="/images/pic-avatar.jpg" size="xl" />
                    <Avatar src="/images/pic-avatar.jpg" size="l" />
                    <Avatar src="/images/pic-avatar.jpg" size="m" />
                    <Avatar src="/images/pic-avatar.jpg" size="s" />
                    <Avatar src="/images/pic-avatar.jpg" size="xs" />
                    <Avatar src="/images/pic-avatar.jpg" size="xxs" />
                </Flexbox>
            ),
            code: '<Avatar src="/images/pic-avatar.jpg" size="xxl" />\n<Avatar src="/images/pic-avatar.jpg" size="xl" />\n<Avatar src="/images/pic-avatar.jpg" size="l" />\n<Avatar src="/images/pic-avatar.jpg" size="m" />\n<Avatar src="/images/pic-avatar.jpg" size="s" />\n<Avatar src="/images/pic-avatar.jpg" size="xs" />\n<Avatar src="/images/pic-avatar.jpg" size="xxs" />',
        },
        {
            title: "With a letter",
            content: (
                <Flexbox gap="s" wrap="wrap">
                    <Avatar size="xxl" color="primary">
                        A
                    </Avatar>

                    <Avatar size="xl" color="secondary">
                        A
                    </Avatar>

                    <Avatar size="l" color="success">
                        A
                    </Avatar>

                    <Avatar size="m" color="danger">
                        A
                    </Avatar>

                    <Avatar size="s" color="warning">
                        A
                    </Avatar>

                    <Avatar size="xs" color="gray">
                        A
                    </Avatar>

                    <Avatar size="xxs" color="black">
                        A
                    </Avatar>
                </Flexbox>
            ),
            code: '<Avatar size="xxl" color="primary">\n    A\n</Avatar>\n\n<Avatar size="xl" color="secondary">\n    A\n</Avatar>\n\n<Avatar size="l" color="success">\n    A\n</Avatar>\n\n<Avatar size="m" color="danger">\n    A\n</Avatar>\n\n<Avatar size="s" color="warning">\n    A\n</Avatar>\n\n<Avatar size="xs" color="gray">\n    A\n</Avatar>\n\n<Avatar size="xxs" color="black">\n    A\n</Avatar>',
        },
        {
            title: "With an icon",
            content: (
                <Flexbox gap="s" wrap="wrap">
                    <Avatar size="xxl" color="primary" icon="user-regular" />
                    <Avatar size="xl" color="secondary" icon="user-regular" />
                    <Avatar size="l" color="success" icon="user-regular" />
                    <Avatar size="m" color="danger" icon="user-regular" />
                    <Avatar size="s" color="warning" icon="user-regular" />
                    <Avatar size="xs" color="gray" icon="user-regular" />
                    <Avatar size="xxs" color="black" icon="user-regular" />
                </Flexbox>
            ),
            code: '<Avatar size="xxl" color="primary" icon="user-regular" />\n<Avatar size="xl" color="secondary" icon="user-regular" />\n<Avatar size="l" color="success" icon="user-regular" />\n<Avatar size="m" color="danger" icon="user-regular" />\n<Avatar size="s" color="warning" icon="user-regular" />\n<Avatar size="xs" color="gray" icon="user-regular" />\n<Avatar size="xxs" color="black" icon="user-regular" />',
        },
        {
            title: "With an icon from Fajny",
            content: (
                <Flexbox gap="s" wrap="wrap">
                    <Avatar size="xxl" color="primary" fajnyIcon="user-solid" />
                    <Avatar size="xl" color="secondary" fajnyIcon="user-solid" />
                    <Avatar size="l" color="success" fajnyIcon="user-solid" />
                    <Avatar size="m" color="danger" fajnyIcon="user-solid" />
                    <Avatar size="s" color="warning" fajnyIcon="user-solid" />
                    <Avatar size="xs" color="gray" fajnyIcon="user-solid" />
                    <Avatar size="xxs" color="black" fajnyIcon="user-solid" />
                </Flexbox>
            ),
            code: '<Avatar size="xxl" color="primary" fajnyIcon="user-solid" />\n<Avatar size="xl" color="secondary" fajnyIcon="user-solid" />\n<Avatar size="l" color="success" fajnyIcon="user-solid" />\n<Avatar size="m" color="danger" fajnyIcon="user-solid" />\n<Avatar size="s" color="warning" fajnyIcon="user-solid" />\n<Avatar size="xs" color="gray" fajnyIcon="user-solid" />\n<Avatar size="xxs" color="black" fajnyIcon="user-solid" />',
        },
    ]

    const propsItems = [
        {
            name: "src",
            type: "String",
            example: "/images/avatar-julien.jpg",
            required: "Yes, if you want to use an avatar with a picture",
        },
        {
            name: "alt",
            type: "String",
            example: "Picture Julien",
            default: "Avatar",
            required: "Yes, if you want to use an avatar with a picture",
        },
        {
            name: "children",
            type: "String",
            example: "J",
            required: "Yes, if you want to use an avatar with a letter",
        },
        {
            name: "fajnyIcon",
            type: "String",
            example: "user-solid",
            possible: commonProps.fajnyIcons,
            default: "",
            required: commonProps.requiredFajnyIcon,
        },
        {
            name: "icon",
            type: "String",
            example: "user",
            required: "Yes, if you want to use your own icon",
        },
        {
            name: "color",
            type: "String",
            example: "success",
            possible: commonProps.colorsShort,
            default: "primary",
        },
        {
            name: "size",
            type: "String",
            example: "s",
            possible: commonProps.spacers,
            default: "xxl",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default AvatarPage
